<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>日志管理</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
      <el-form :inline="true" :model="keywords" class="demo-form-inline">
        <el-form-item label="">
          <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始日期" class="mr15"></el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束日期" class="mr15"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksearch">查询</el-button>
          <el-button type="primary" @click="clickexcel">导出</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表 -->
      <el-table v-loading="loading" :data="logList" border stripe>
        <el-table-column prop="Adminusername" label="睿云账号"></el-table-column>
        <el-table-column prop="Jigouname" label="所属机构"></el-table-column>
        <el-table-column prop="Num" label="登录次数"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pages">
        <el-pagination
        @current-change="handleCurrentPageChange"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="listnum"
        :current-page.sync="selectedPageNo">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyLogs',
  data () {
    return {
      loading: false,
      keywords: {
        begintime: '',
        endtime: ''
      },
      logList: [],
      selectedPageNo: 1,
      listnum: 0
    }
  },
  mounted () {
    this.keywords.begintime = Vue.prototype.getFirstDay()
    this.keywords.endtime = Vue.prototype.getLastDay()
    this.GetLogErpLoginList()
    this.GetLogErpLoginNum()
  },
  methods: {
    clicksearch () {
      this.selectedPageNo = 1
      this.GetLogErpLoginList()
      this.GetLogErpLoginNum()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetLogErpLoginList()
      this.GetLogErpLoginNum()
    },
    clickexcel () {
      this.apiExcelErpDlsLogErpLogin()
    },
    GetLogErpLoginNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetLogErpLoginNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.listnum = response.data.Num
          }
		  Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetLogErpLoginList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetLogErpLoginList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.logList = []
            response.data.List.filter((item1, i1) => {
              that.logList.push({ Adminusername: item1.Adminusername, Jigouname: item1.Jigouname, Num: item1.Num })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiExcelErpDlsLogErpLogin: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelErpDlsLogErpLogin, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
